// Use relative URL when served from same origin, or absolute URL from env
export const API_BASE_URL = import.meta.env.VITE_API_URL ?? '';
